var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('h1',{directives:[{name:"t",rawName:"v-t",value:('p.pageNotFound.title'),expression:"'p.pageNotFound.title'"}],staticClass:"reset-margin"}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('p.pageNotFound.message.pageNotFound'),expression:"'p.pageNotFound.message.pageNotFound'"}]})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65f6b184","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageNotFound.vue
// module id = null
// module chunks = 